import { tableFiltersUrl } from '../../utils/helper'
import request from '../axiosInterceptor'

const WorkflowBuilderModule = {
  getWorkflowForms(subsidiaryMasterId: string, data?: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms?subsidiary_master_id=${subsidiaryMasterId}${data ? `&${tableFiltersUrl(data)}` : ''}`,
      method: 'get',
    })
  },

  createWorkflowForm(payload: { name: string; workflow_type: string }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms`,
      method: 'post',
      data: payload,
    })
  },

  getMasterFields(params: { workflow_type?: string; field_category?: string } = {}) {
    const qs = new URLSearchParams({
      workflow_type: params.workflow_type || 'statistics_capture',
      field_category: params.field_category || 'user_input',
    }).toString()
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/master-fields?${qs}`,
      method: 'get',
    })
  },

  createMasterField(payload: {
    name: string
    field_key: string
    data_type: string
    field_category: string
    workflow_type: string
    placeholder?: string
    default_value?: string
    config?: any
    expression?: string
  }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/master-fields`,
      method: 'post',
      data: payload,
    })
  },

  getFormCanvas(formId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}`,
      method: 'get',
    })
  },

  saveFormCanvas(
    formId: number,
    payload: {
      name?: string
      sections: Array<{
        id?: number
        name: string
        sequence: number
        fields: Array<{
          id?: number
          sequence: number
          master_field_id: number
          required?: boolean
          show_in_app?: boolean
        }>
      }>
    },
  ) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}`,
      method: 'put',
      data: payload,
    })
  },

  updateMasterFieldExpression(fieldId: number, payload: { expression: string }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/master-fields/${fieldId}`,
      method: 'patch',
      data: payload,
    })
  },

  publishForm(formId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/publish`,
      method: 'post',
    })
  },

  duplicateForm(formId: number, name?: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/duplicate`,
      method: 'post',
      data: { name: name || null },
    })
  },

  attachFormToProject(formId: number, projectDetailsId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/projects/${projectDetailsId}`,
      method: 'post',
    })
  },

  detachFormFromProject(formId: number, projectDetailsId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/projects/${projectDetailsId}`,
      method: 'delete',
    })
  },

  getFormProjects(formId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/projects`,
      method: 'get',
    })
  },

  getProjectForms(projectDetailsId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/projects/${projectDetailsId}/forms`,
      method: 'get',
    })
  },

  getFormSchedules(formId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/schedules`,
      method: 'get',
    })
  },

  getProjectFormSchedules(formId: number, projectDetailsId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/projects/${projectDetailsId}/schedules`,
      method: 'get',
    })
  },

  deactivateForm(formId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/deactivate`,
      method: 'post',
    })
  },

  reactivateForm(formId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/workflow-builder/forms/${formId}/reactivate`,
      method: 'post',
    })
  },
}

export default WorkflowBuilderModule
